
import Swiper from 'swiper';
import 'swiper/css';
export const slider = () => {
    var swiperFrontpage = new Swiper(".front-page-gallery", {
        slidesPerView: 3,
        spaceBetween: 10, // domyślnie
        breakpoints: {
            0: { // od najmniejszej szerokości
                spaceBetween: 5,
                slidesPerView: 1.2
            },
            768:{
                slidesPerView: 2,
            },
            992: { // od 992px w górę
                slidesPerView: 3,
                spaceBetween: 10
            }
        }
    });
}